import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const HeadingIcon: React.FC<AddIconProps> = ({ size = 22, color = '#0556CB', className, onClick }) => (
  <svg width="48" height="40" viewBox="0 0 48 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.0373 0H0V3.34427H6.8202V23.5942H10.1645V3.34427H17.0373V0Z" fill={color} fillOpacity="0.3" />
    <path d="M27.0967 7.8999H13.6143V11.2442H18.6702V23.5943H22.0144V11.2442H27.0967V7.8999Z" fill={color} fillOpacity="0.3" />
    <rect x="30.126" y="0.128296" width="17.4096" height="3.16211" fill={color} fillOpacity="0.15" />
    <rect x="30.126" y="7.07507" width="17.4096" height="3.16211" fill={color} fillOpacity="0.15" />
    <rect x="30.126" y="14.022" width="17.4096" height="3.16211" fill={color} fillOpacity="0.15" />
    <rect x="30.126" y="20.9688" width="17.4096" height="3.16211" fill={color} fillOpacity="0.15" />
    <rect x="0.0126953" y="26.6218" width="47.6749" height="3.16211" fill={color} fillOpacity="0.15" />
    <rect x="0.0126953" y="31.7299" width="47.6749" height="3.16211" fill={color} fillOpacity="0.15" />
    <rect x="0.0126953" y="36.8379" width="47.6749" height="3.16211" fill={color} fillOpacity="0.15" />
  </svg>

);

export default HeadingIcon;
